
document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.soil-nav-toggle');
  const nav = document.querySelector('.soil-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  const categoryLinks = [...document.querySelectorAll('.soil-category-nav a')];
  const groups = [...document.querySelectorAll('[data-menu-group]')];
  if (categoryLinks.length && groups.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter(entry => entry.isIntersecting)
        .sort((a,b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!visible) return;
      categoryLinks.forEach(link => {
        link.classList.toggle('is-active', link.getAttribute('href') === `#${visible.target.id}`);
      });
    }, {rootMargin:'-25% 0px -60% 0px',threshold:[0,.1,.25,.5]});
    groups.forEach(group => observer.observe(group));
  }

  document.querySelectorAll('[data-soil-plans]').forEach(initMealPlans);
});

function initMealPlans(root) {
  const fallbackPrices = {
    "100": {"22":{"3m2s":1215,"2m1s":810,"1m1s":607},"26":{"3m2s":1435,"2m1s":957,"1m1s":718}},
    "150": {"22":{"3m2s":1822,"2m1s":1215,"1m1s":910},"26":{"3m2s":2153,"2m1s":1435,"1m1s":1076}},
    "200": {"22":{"3m2s":2307,"2m1s":1620,"1m1s":1215},"26":{"3m2s":2727,"2m1s":1915,"1m1s":1215}}
  };
  const deliveryPrices = {"22":320,"26":400};

  let products = {"100":[],"150":[],"200":[],"delivery":[]};
  const dataEl = root.querySelector('[data-plan-products]');
  if (dataEl) {
    try { products = JSON.parse(dataEl.textContent); } catch (e) {}
  }

  const state = {size:"100",days:"22",package:"3m2s",fulfillment:"pickup"};
  const sizeButtons = [...root.querySelectorAll('[data-size]')];
  const dayButtons = [...root.querySelectorAll('[data-days]')];
  const packageButtons = [...root.querySelectorAll('[data-package]')];
  const fulfillmentButtons = [...root.querySelectorAll('[data-fulfillment]')];
  const addButton = root.querySelector('[data-add-plan]');
  const summarySize = root.querySelector('[data-summary-size]');
  const summaryDays = root.querySelector('[data-summary-days]');
  const summaryFulfillment = root.querySelector('[data-summary-fulfillment]');
  const summaryPackage = root.querySelector('[data-summary-package]');
  const summarySchedule = root.querySelector('[data-summary-schedule]');
  const summaryPrice = root.querySelector('[data-summary-price]');
  const summaryBasePrice = root.querySelector('[data-summary-base-price]');
  const summaryDeliveryPrice = root.querySelector('[data-summary-delivery-price]');
  const deliveryBreakdown = root.querySelector('[data-delivery-breakdown]');
  const deliveryChoicePrice = root.querySelector('[data-delivery-choice-price]');
  const planNote = root.querySelector('[data-plan-note]');
  const deliveryPanel = root.querySelector('[data-soil-plan-delivery]');

  const packageLabels = {
    "3m2s":"3 Meals + 2 Snacks / Day",
    "2m1s":"2 Meals + 1 Snack / Day",
    "1m1s":"1 Meal + 1 Snack / Day"
  };

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9+]+/g,' ').replace(/\s+/g,' ').trim();
  }
  function moneyNumber(value) {
    const cleaned = String(value || '').replace(/[^0-9.,]/g,'').replace(/,/g,'');
    const n = Number.parseFloat(cleaned);
    return Number.isFinite(n) ? n : null;
  }
  function formatSar(value) {
    return new Intl.NumberFormat('en-US', {maximumFractionDigits:0}).format(value);
  }

  function findVariant() {
    const list = products[state.size] || [];
    const dayNeedle = `${state.days} days`;
    const packageNeedles = {
      "3m2s":["3 meals + 2 snacks","3 meals 2 snacks"],
      "2m1s":["2 meals + 1 snack","2 meals 1 snack"],
      "1m1s":["1 meal + 1 snack","1 meal 1 snack"]
    }[state.package];
    return list.find(variant => {
      const joined = (variant.options || []).map(normalize).join(' | ');
      return joined.includes(dayNeedle) && packageNeedles.some(needle => joined.includes(normalize(needle)));
    });
  }

  function findDeliveryVariant() {
    const list = products.delivery || [];
    const dayNeedle = `${state.days} days`;
    return list.find(variant => {
      const joined = [...(variant.options || []), variant.title || ''].map(normalize).join(' | ');
      return joined.includes(dayNeedle) || joined === state.days || joined.includes(state.days);
    });
  }

  function render() {
    sizeButtons.forEach(btn => btn.classList.toggle('is-active', btn.dataset.size === state.size));
    dayButtons.forEach(btn => btn.classList.toggle('is-active', btn.dataset.days === state.days));
    packageButtons.forEach(btn => btn.classList.toggle('is-active', btn.dataset.package === state.package));
    fulfillmentButtons.forEach(btn => btn.classList.toggle('is-active', btn.dataset.fulfillment === state.fulfillment));

    summarySize.textContent = `${state.size}g`;
    summaryDays.textContent = `${state.days} Days`;
    summaryFulfillment.textContent = state.fulfillment === 'delivery' ? 'Delivery' : 'Pickup';
    summaryPackage.textContent = packageLabels[state.package];
    summarySchedule.textContent = state.days === "22" ? "Excluding Fridays & Saturdays" : "Excluding Fridays";

    const variant = findVariant();
    const fallbackBase = fallbackPrices[state.size][state.days][state.package];
    const actualBase = variant ? moneyNumber(variant.price) : null;
    const base = actualBase ?? fallbackBase;
    const fallbackDelivery = deliveryPrices[state.days];
    const deliveryVariant = findDeliveryVariant();
    const actualDelivery = deliveryVariant ? moneyNumber(deliveryVariant.price) : null;
    const delivery = actualDelivery ?? fallbackDelivery;
    const total = base + (state.fulfillment === 'delivery' ? delivery : 0);

    summaryBasePrice.textContent = `${formatSar(base)} SAR`;
    summaryDeliveryPrice.textContent = `${formatSar(delivery)} SAR`;
    deliveryBreakdown.hidden = state.fulfillment !== 'delivery';
    deliveryChoicePrice.textContent = `+${formatSar(deliveryPrices[state.days])} SAR for ${state.days} days`;
    summaryPrice.textContent = formatSar(total);

    root.querySelectorAll('[data-price-label]').forEach(el => {
      const packageKey = el.dataset.priceLabel;
      el.textContent = `${formatSar(fallbackPrices[state.size][state.days][packageKey])} SAR`;
    });

    if (deliveryPanel) {
      const showDelivery = state.fulfillment === 'delivery';
      deliveryPanel.hidden = !showDelivery;
      if (showDelivery) {
        requestAnimationFrame(() => deliveryPanel.dispatchEvent(new CustomEvent('soil:init-map')));
      }
    }

    const planReady = Boolean(variant && variant.available);
    const deliveryReady = state.fulfillment !== 'delivery' || Boolean(deliveryVariant && deliveryVariant.available);

    if (planReady && deliveryReady) {
      addButton.disabled = false;
      addButton.textContent = 'Continue to Checkout';
      planNote.textContent = state.fulfillment === 'delivery'
        ? `Delivery fee of ${formatSar(delivery)} SAR is included. Add your location details, then continue directly to secure checkout.`
        : 'Pickup selected. Continue directly to secure Shopify checkout.';
    } else if (variant && !variant.available) {
      addButton.disabled = true;
      addButton.textContent = 'Selected Plan Unavailable';
      planNote.textContent = 'This Shopify plan variant is currently unavailable.';
    } else if (state.fulfillment === 'delivery' && planReady && deliveryVariant && !deliveryVariant.available) {
      addButton.disabled = true;
      addButton.textContent = 'Delivery Unavailable';
      planNote.textContent = 'The delivery fee variant for this duration is currently unavailable.';
    } else {
      addButton.disabled = true;
      addButton.textContent = 'Plan Setup Required';
      planNote.textContent = 'The Shopify meal-plan product setup is incomplete.';
    }
  }

  function deliveryDetails() {
    if (!deliveryPanel) return null;
    return {
      district: deliveryPanel.querySelector('[data-plan-district]')?.value.trim() || '',
      street: deliveryPanel.querySelector('[data-plan-street]')?.value.trim() || '',
      building: deliveryPanel.querySelector('[data-plan-building]')?.value.trim() || '',
      unit: deliveryPanel.querySelector('[data-plan-unit]')?.value.trim() || '',
      notes: deliveryPanel.querySelector('[data-plan-notes]')?.value.trim() || '',
      lat: deliveryPanel.querySelector('[data-plan-map-lat]')?.value.trim() || '',
      lng: deliveryPanel.querySelector('[data-plan-map-lng]')?.value.trim() || '',
      mapLink: deliveryPanel.querySelector('[data-plan-map-link]')?.value.trim() || ''
    };
  }

  function validateDelivery() {
    if (state.fulfillment !== 'delivery') return true;
    const details = deliveryDetails();
    if (!details) return false;

    const required = [
      ['[data-plan-district]', details.district],
      ['[data-plan-street]', details.street],
      ['[data-plan-building]', details.building]
    ];
    const missing = required.find(([,value]) => !value);
    if (missing) {
      const field = deliveryPanel.querySelector(missing[0]);
      field?.focus();
      field?.scrollIntoView({behavior:'smooth',block:'center'});
      planNote.textContent = 'Please complete the delivery address before continuing.';
      return false;
    }

    if (!details.lat || !details.lng || !details.mapLink) {
      const status = deliveryPanel.querySelector('[data-plan-map-status]');
      if (status) {
        status.textContent = 'Please drop a pin on your exact delivery location or use your current location.';
        status.classList.add('is-error');
      }
      deliveryPanel.querySelector('[data-soil-plan-map]')?.scrollIntoView({behavior:'smooth',block:'center'});
      planNote.textContent = 'Please select your exact delivery location before continuing.';
      return false;
    }
    return true;
  }

  sizeButtons.forEach(btn => btn.addEventListener('click', () => {state.size = btn.dataset.size; render();}));
  dayButtons.forEach(btn => btn.addEventListener('click', () => {state.days = btn.dataset.days; render();}));
  packageButtons.forEach(btn => btn.addEventListener('click', () => {state.package = btn.dataset.package; render();}));
  fulfillmentButtons.forEach(btn => btn.addEventListener('click', () => {state.fulfillment = btn.dataset.fulfillment; render();}));

  addButton.addEventListener('click', async () => {
    const variant = findVariant();
    if (!variant || !variant.available || !validateDelivery()) return;

    const items = [{
      id:Number(variant.id),
      quantity:1,
      properties:{
        'Serving Size':`${state.size}g`,
        'Duration':`${state.days} Days`,
        'Daily Plan':packageLabels[state.package],
        'Fulfillment':state.fulfillment === 'delivery' ? 'Delivery' : 'Pickup'
      }
    }];

    if (state.fulfillment === 'delivery') {
      const deliveryVariant = findDeliveryVariant();
      if (!deliveryVariant || !deliveryVariant.available) return;
      items.push({
        id:Number(deliveryVariant.id),
        quantity:1,
        properties:{
          'Meal Plan Duration':`${state.days} Days`,
          'Fulfillment':'Delivery'
        }
      });
    }

    const details = deliveryDetails();
    const attributes = state.fulfillment === 'delivery' ? {
      'Fulfillment':'Delivery',
      'Delivery District':details.district,
      'Delivery Street':details.street,
      'Delivery Building Number':details.building,
      'Delivery Apartment Unit':details.unit,
      'Delivery Address Details':details.notes,
      'Delivery Latitude':details.lat,
      'Delivery Longitude':details.lng,
      'Delivery Map Link':details.mapLink
    } : {
      'Fulfillment':'Pickup',
      'Delivery District':'',
      'Delivery Street':'',
      'Delivery Building Number':'',
      'Delivery Apartment Unit':'',
      'Delivery Address Details':'',
      'Delivery Latitude':'',
      'Delivery Longitude':'',
      'Delivery Map Link':''
    };

    const original = addButton.textContent;
    addButton.disabled = true;
    addButton.textContent = 'Preparing Checkout…';

    try {
      const addResponse = await fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items})
      });
      if (!addResponse.ok) throw new Error('Unable to add plan');

      const attributeResponse = await fetch('/cart/update.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({attributes})
      });
      if (!attributeResponse.ok) throw new Error('Unable to save checkout details');

      window.location.assign('/checkout');
    } catch (e) {
      addButton.disabled = false;
      addButton.textContent = original;
      planNote.textContent = 'We could not prepare checkout. Please try again.';
    }
  });

  render();
}
